import i18n from "i18next";

const resources = {
  ar: {
    btn_get_approval: "الحصول على موافقة",
    msg_select_operations_first: "الرجاء اختيار العمليات أولاً",
    msg_branch_missing: "معرّف الفرع مفقود",
    msg_approval_success: "تم إرسال طلب الموافقة بنجاح",
    msg_approval_failed: "فشل إرسال الطلب",
    msg_operations_no_longer_submittable: "لم يعد بالإمكان إرسال هذه العمليات. أغلق هذه النافذة وتحقق من حالتها.",
    modal_title: "إرسال طلب موافقة DHS",
    btn_cancel: "إلغاء",
    btn_submit: "إرسال",
    btn_previous: "السابق",
    btn_next: "التالي",
    step_general: "عام",
    step_practitioner: "الممارس",
    step_diagnosis: "التشخيص",
    step_attachments: "المرفقات",
    label_visit_reason: "سبب الزيارة",
    label_transaction_type: "نوع المعاملة",
    label_claim_request_type: "نوع طلب الموافقة المسبقة",
    label_priority: "الأولوية",
    label_encounter_status: "حالة الزيارة",
    label_encounter_class: "فئة الزيارة",
    label_service_event_type: "نوع الحدث الخدمي",
    label_triage_category: "فئة الفرز",
    label_triage_date: "تاريخ الفرز",
    label_intended_length: "مدة الإقامة المقصودة",
    label_practitioner_name: "اسم الممارس",
    label_scfhs: "رقم الهيئة السعودية للتخصصات الصحية",
    label_speciality_code: "رمز التخصص",
    label_speciality_name: "اسم التخصص",
    label_diagnosis_type: "نوع التشخيص",
    label_diagnosis_code: "رمز التشخيص",
    label_diagnosis_description: "وصف التشخيص",
    label_chief_complaint: "الشكوى الرئيسية",
    label_investigation_result: "نتيجة الفحص",
    label_treatment_plan: "خطة العلاج",
    label_patient_history: "تاريخ المريض",
    label_physical_examination: "الفحص البدني",
    label_history_present_illness: "تاريخ المرض الحالي",
    btn_add_diagnosis: "إضافة تشخيص",
    btn_remove: "إزالة",
    msg_unsupported_file: "غير مدعوم من Nphies",
    msg_file_type_required: "مطلوب تحديد نوع الملف",
    placeholder_select_file_type: "اختر نوع الملف",
    required: "مطلوب",
    step_patient_info: "معلومات المريض",
    step_request_info: "معلومات الطلب",
    step_encounter_info: "معلومات الزيارة",
    btn_use_code: 'استخدام هذا الكود',
    msg_no_diagnosis_found: 'لم يتم العثور على تشخيص. اكتب كوداً للإدخال يدوياً.',
    step_services: "الخدمات",
    step_review: "المراجعة",
    title_patient_information: "معلومات المريض",
    label_marital_status: "الحالة الاجتماعية",
    label_date_of_birth: "تاريخ الميلاد",
    label_gender: "الجنس",
    label_occupation: "المهنة",
    label_identifier_type: "نوع الهوية",
    label_identifier_id: "رقم الهوية",
    label_membership_number: "رقم العضوية",
    "auth.nameLength": "لا يمكن أن يتجاوز رقم الهوية 100 حرف",
    label_policy_number: "رقم البوليصة",
    label_policy_holder_name: "اسم صاحب البوليصة",
    label_class_name: "فئة البوليصة",
    title_claim_preauth_request: "طلب الموافقة المسبقة",
    label_is_transferal: "تحويل",
    title_encounter_details: "تفاصيل الزيارة",
    label_admission_date: "تاريخ الدخول",
    label_discharge_date: "تاريخ الخروج",
    msg_discharge_date_error: "يجب أن يكون تاريخ الخروج بعد أو مساوياً لتاريخ الدخول",
    msg_admission_date_error: "لا يمكن أن يكون تاريخ القبول بعد أقرب تاريخ خدمة",
    msg_discharge_date_service_error: "لا يمكن أن يكون تاريخ الخروج قبل آخر تاريخ خدمة",
    placeholder_search_practitioner: "البحث عن ممارس",
    label_scfhs_license: "ترخيص الهيئة السعودية للتخصصات الصحية",
    title_diagnosis_information: "معلومات التشخيص",
    msg_missing_code: "الرمز مفقود",
    msg_missing_type: "النوع مفقود",
    msg_at_least_one_diagnosis: "مطلوب تشخيص واحد على الأقل",
    label_code: "الرمز",
    label_type: "النوع",
    label_description: "الوصف",
    title_medical_details: "التفاصيل الطبية",
    title_services_procedures: "الخدمات / الإجراءات",
    label_service_code: "رمز الخدمة",
    label_quantity: "الكمية",
    label_branch: "الفرع",
    label_unit_price: "سعر الوحدة",
    label_vat_percentage: "نسبة الضريبة",
    label_discount_percentage: "نسبة الخصم",
    label_discount_amount: "قيمة الخصم",
    label_vat_amount: "ضريبة القيمة المضافة (15%)",
    msg_vat_calculated_auto: "يتم الحساب تلقائيًا بنسبة 15٪ بعد الخصم",
    label_service_type: "نوع الخدمة",
    title_attachments: "المرفقات",
    title_supported_file_formats: "تنسيقات الملفات المدعومة",
    desc_supported_file_formats: "يرجى ملاحظة أنه يتم دعم ملفات PDF و JPEG و JPG و PNG فقط. لا يمكن تحديد الملفات غير المدعومة.",
    label_include: "تضمين",
    label_file_name: "اسم الملف",
    label_content_type: "نوع المحتوى",
    label_file_type: "نوع الملف",
    label_unknown: "غير معروف",
    msg_unsupported_file_format: "تنسيق ملف غير مدعوم",
    label_view: "عرض",
    title_review_submit: "مراجعة وإرسال",
    title_diagnosis_medical_details: "التشخيص والتفاصيل الطبية",
    label_name: "الاسم",
    label_status: "الحالة",
    label_qty: "الكمية",
    label_yes: "نعم",
    label_no: "لا",
    relatedApprovalNumber: "رقم الموافقة المرتبط",
    relatedApprovalRequired: "رقم الموافقة المرتبط مطلوب",
    "validation.nationalId.sa.format": "يجب أن يتكون رقم الهوية من 10 أرقام بالضبط",
    "validation.nationalId.sa.national_id_start": "يجب أن تبدأ الهوية الوطنية السعودية بالرقم 1",
    "validation.nationalId.sa.iqama_start": "يجب أن يبدأ رقم الإقامة بالرقم 2",
    "validation.nationalId.eg.format": "يجب أن يتكون الرقم القومي المصري من 14 رقماً بالضبط",
    "validation.nationalId.eg.invalid": "رقم الهوية الوطنية المصري يحتوي على تاريخ أو قرن غير صالح",
    "national_id": "الهوية الوطنية",
    "iqama": "الإقامة",
    "passport": "جواز السفر",
    "visa": "تأشيرة",
    "border_number": "رقم الحدود",
    "displaced_person": "نازح",
    "other": "أخرى",
    "residency": "الإقامة",
    "driver_license": "أخرى",
    "OTHER": "أخرى",
    male: "ذكر",
    female: "أنثى",
    married: "متزوج",
    single: "أعزب",
    divorced: "مطلق",
    separated: "منفصل",
    widowed: "أرمل",
    "Chiropractor": "أخصائي تقويم العمود الفقري",
    "Doctor": "طبيب",
    "Dentist": "طبيب أسنان",
    "Dietitian or Nutritionist": "أخصائي تغذية",
    "Optometrist": "فاحص بصريات",
    "Pharmacist": "صيدلي",
    "Physician": "طبيب",
    "Physician Assistant": "مساعد طبيب",
    "Podiatrist": "طبيب أقدام",
    "Registered Nurse": "ممرض مسجل",
    "Therapist": "معالج",
    "Veterinarian": "طبيب بيطري",
    "Health Technologist or Technician": "تقني صحي أو فني",
    "Other Healthcare Practitioners and Technical Occupation": "ممارسون صحيون ومهن فنية أخرى",
    "Nursing, Psychiatric, or Home Health Aide": "مساعد تمريض أو طب نفسي أو صحة منزلية",
    "Occupational and Physical Therapist Assistant or Aide": "مساعد معالج مهني أو طبيعي",
    "Other Healthcare Support Occupation": "مهن دعم صحي أخرى",
    "Chief Executive": "رئيس تنفيذي",
    "General and Operations Manager": "مدير عام وعمليات",
    "Advertising, Marketing, Promotions, Public Relations, and Sales Manager": "مدير إعلانات، تسويق، ترويج، علاقات عامة، ومبيعات",
    "Operations Specialties Manager (e.g., IT or HR Manager)": "مدير تخصصات العمليات (مثل مدير تقنية المعلومات أو الموارد البشرية)",
    "Construction Manager": "مدير إنشاءات",
    "Engineering Manager": "مدير هندسي",
    "Accountant, Auditor": "محاسب، مدقق حسابات",
    "Business Operations or Financial Specialist": "أخصائي عمليات تجارية أو مالي",
    "Business Owner": "صاحب عمل",
    "Other Business, Executive, Management, Financial Occupation": "مهن أعمال، تنفيذية، إدارية، مالية أخرى",
    "Architect, Surveyor, or Cartographer": "مهندس معماري، مساح، أو رسام خرائط",
    "Engineer": "مهندس",
    "Other Architecture and Engineering Occupation": "مهن هندسة وعمارة أخرى",
    "Postsecondary Teacher (e.g., College Professor)": "مدرس ما بعد الثانوي (مثل أستاذ جامعي)",
    "Primary, Secondary, or Special Education School Teacher": "مدرس مدرسة ابتدائية، ثانوية، أو تربية خاصة",
    "Other Teacher or Instructor": "مدرس أو مدرب آخر",
    "Other Education, Training, and Library Occupation": "مهن تعليم، تدريب، ومكتبات أخرى",
    "Arts, Design, Entertainment, Sports, and Media Occupations": "مهن الفنون، التصميم، الترفيه، الرياضة، والإعلام",
    "Computer Specialist, Mathematical Science": "أخصائي حاسوب، علوم رياضية",
    "Counselor, Social Worker, or Other Community and Social Service Specialist": "مستشار، أخصائي اجتماعي، أو أخصائي خدمة مجتمعية واجتماعية آخر",
    "Lawyer, Judge": "محام، قاض",
    "Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)": "عالم حياة (مثل عالم حيوان، أغذية، تربة، أو أحياء)",
    "Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)": "عالم فيزيائي (مثل فلكي، فيزيائي، كيميائي، هيدرولوجي)",
    "Religious Worker (e.g., Clergy, Director of Religious Activities or Education)": "عامل ديني (مثل رجل دين، مدير أنشطة دينية أو تعليم)",
    "Social Scientist and Related Worker": "عالم اجتماعي وعامل ذو صلة",
    "Other Professional Occupation": "مهن مهنية أخرى",
    "Supervisor of Administrative Support Workers": "مشرف عمال الدعم الإداري",
    "Financial Clerk": "كاتب مالي",
    "Secretary or Administrative Assistant": "سكرتير أو مساعد إداري",
    "Material Recording, Scheduling, and Dispatching Worker": "عامل تسجيل مواد، جدولة، وإرسال",
    "Other Office and Administrative Support Occupation": "مهن مكتبية ودعم إداري أخرى",
    "Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)": "خدمة حماية (مثل إطفاء، ضابط شرطة، ضابط إصلاحية)",
    "Chef or Head Cook": "طاه أو رئيس طهاة",
    "Cook or Food Preparation Worker": "طباخ أو عامل تحضير طعام",
    "Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)": "عامل تقديم طعام ومشروبات",
    "Building and Grounds Cleaning and Maintenance": "تنظيف وصيانة المباني والمرافق",
    "Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)": "عناية شخصية وخدمة (مثل مصفف شعر، مضيف طيران)",
    "Sales Supervisor, Retail Sales": "مشرف مبيعات، مبيعات تجزئة",
    "Retail Sales Worker": "عامل مبيعات تجزئة",
    "Insurance Sales Agent": "وكيل مبيعات تأمين",
    "Sales Representative": "مندوب مبيعات",
    "Real Estate Sales Agent": "وكيل مبيعات عقارات",
    "Other Services Occupation": "مهن خدمات أخرى",
    "Construction and Extraction (e.g., Construction Laborer, Electrician)": "بناء واستخراج (مثل عامل بناء، كهربائي)",
    "Farming, Fishing, and Forestry": "زراعة، صيد، وحراجة",
    "Installation, Maintenance, and Repair": "تركيب، صيانة، وإصلاح",
    "Production Occupations": "مهن الإنتاج",
    "Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation": "زراعة، صيانة، إصلاح، وحرف ماهرة أخرى",
    "Aircraft Pilot or Flight Engineer": "طيار أو مهندس طيران",
    "Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)": "مشغل مركبات (مثل سائق إسعاف، حافلة، تاكسي، أو شاحنة)",
    "Other Transportation Occupation": "مهن نقل أخرى",
    "Military": "عسكري",
    "Homemaker": "ربة منزل",
    "Other Occupation": "مهنة أخرى",
    "Don't Know": "لا أعرف",
    "Not Applicable": "لا ينطبق",
    msg_quantity_validation_error_title: "تم إيقاف إرسال DHS",
    msg_quantity_validation_error: "يتطلب DHS للأسنان أن تكون كمية كل عملية مُرسَلة تساوي 1. يجب تعديل كمية العمليات التالية إلى 1 قبل الإرسال:",
    msg_mixed_branch_validation_error_title: "تم إيقاف إرسال DHS",
    msg_mixed_branch_validation_error: "يجب أن تنتمي جميع العمليات المُرسَلة إلى نفس الفرع، لأن الطلب يُقدَّم باسم الفرع الذي قدّم الخدمة. العمليات المحددة تنتمي إلى فروع مختلفة:",
    msg_group_teeth_validation_error_title: "تم إيقاف إرسال DHS",
    msg_group_teeth_validation_error: "يرفض DHS الخدمات المخصصة لأكثر من سن واحد. يجب تقسيم العمليات التالية حسب السن قبل الإرسال:",
    msg_arch_tooth_validation_error_title: "تم إيقاف إرسال DHS",
    msg_arch_tooth_validation_error: "يتطلب نفيس رقم سن بترميز FDI. الخدمات المخصصة للفك الكامل أو للفم بالكامل ليس لها مقابل في FDI ولا يمكن إرسالها. يجب تخصيص العمليات التالية لسن محدد قبل الإرسال:",
    label_tooth_number: "رقم السن"
  },
  en: {
    btn_get_approval: "GET Approval",
    msg_select_operations_first: "Please select operations first",
    msg_branch_missing: "Branch ID is missing",
    msg_approval_success: "Approval submitted successfully",
    msg_approval_failed: "Submission failed",
    msg_operations_no_longer_submittable: "These operations can no longer be submitted. Close this window and check their status.",
    modal_title: "DHS Approval Submission",
    btn_cancel: "Cancel",
    btn_submit: "Submit",
    btn_previous: "Previous",
    btn_next: "Next",
    step_general: "General",
    step_practitioner: "Practitioner",
    step_diagnosis: "Diagnosis",
    step_attachments: "Attachments",
    label_visit_reason: "Visit Reason",
    label_transaction_type: "Transaction Type",
    label_claim_request_type: "Claim Preauth Request Type",
    label_priority: "Priority",
    label_encounter_status: "Encounter Status",
    label_encounter_class: "Encounter Class",
    label_service_event_type: "Service Event Type",
    label_triage_category: "Triage Category",
    label_triage_date: "Triage Date",
    label_intended_length: "Intended Length of Stay",
    label_practitioner_name: "Practitioner Name",
    label_scfhs: "SCFHS",
    label_speciality_code: "Speciality Code",
    label_speciality_name: "Speciality Name",
    label_diagnosis_type: "Diagnosis Type",
    label_diagnosis_code: "Diagnosis Code",
    label_diagnosis_description: "Diagnosis Description",
    label_chief_complaint: "Chief Complaint",
    label_investigation_result: "Investigation Result",
    label_treatment_plan: "Treatment Plan",
    label_patient_history: "Patient History",
    label_physical_examination: "Physical Examination",
    label_history_present_illness: "History of Present Illness",
    btn_add_diagnosis: "Add Diagnosis",
    btn_remove: "Remove",
    msg_unsupported_file: "Not supported by Nphies",
    msg_file_type_required: "File type selection is required",
    placeholder_select_file_type: "Select file type",
    required: "Required",
    step_patient_info: "Patient Info",
    step_request_info: "Request Info",
    step_encounter_info: "Encounter Info",
    btn_use_code: 'Use this code',
    msg_no_diagnosis_found: 'No diagnosis found. Type a code to enter manually.',
    step_services: "Services",
    step_review: "Review",
    title_patient_information: "Patient Information",
    label_marital_status: "Marital Status",
    label_date_of_birth: "Date of Birth",
    label_gender: "Gender",
    label_occupation: "Occupation",
    label_identifier_type: "Identifier Type",
    label_identifier_id: "Identifier ID",
    label_membership_number: "Membership Number",
    "auth.nameLength": "ID cannot exceed 100 characters",
    label_policy_number: "Policy Number",
    label_policy_holder_name: "Policy Holder Name",
    label_class_name: "Policy Class",
    title_claim_preauth_request: "Claim Preauth Request",
    label_is_transferal: "Is Transferal",
    title_encounter_details: "Encounter Details",
    label_admission_date: "Admission Date",
    label_discharge_date: "Discharge Date",
    msg_discharge_date_error: "Discharge date must be after or equal to admission date",
    msg_admission_date_error: "Admission Date cannot be later than the earliest service date",
    msg_discharge_date_service_error: "Discharge Date cannot be earlier than the latest service date",
    placeholder_search_practitioner: "Search practitioner",
    label_scfhs_license: "SCFHS License",
    title_diagnosis_information: "Diagnosis Information",
    msg_missing_code: "Missing code",
    msg_missing_type: "Missing type",
    msg_at_least_one_diagnosis: "At least one diagnosis is required",
    label_code: "Code",
    label_type: "Type",
    label_description: "Description",
    title_medical_details: "Medical Details",
    title_services_procedures: "Services / Procedures",
    label_service_code: "Service Code",
    label_quantity: "Quantity",
    label_branch: "Branch",
    label_unit_price: "Unit Price",
    label_vat_percentage: "VAT %",
    label_discount_percentage: "Discount %",
    label_discount_amount: "Discount Amount",
    label_vat_amount: "VAT (15%)",
    msg_vat_calculated_auto: "Calculated automatically at 15% after discount",
    label_service_type: "Service Type",
    title_attachments: "Attachments",
    title_supported_file_formats: "Supported File Formats",
    desc_supported_file_formats: "Please note that only PDF, JPEG, JPG, and PNG files are supported for DHS approvals. Unsupported files cannot be selected.",
    label_include: "Include",
    label_file_name: "File Name",
    label_content_type: "Content Type",
    label_file_type: "File Type",
    label_unknown: "Unknown",
    msg_unsupported_file_format: "Unsupported file format",
    label_view: "View",
    title_review_submit: "Review & Submit",
    title_diagnosis_medical_details: "Diagnosis & Medical Details",
    label_name: "Name",
    label_status: "Status",
    label_qty: "Qty",
    label_yes: "Yes",
    label_no: "No",
    relatedApprovalNumber: "Related Approval Number",
    relatedApprovalRequired: "Related Approval Number is required",
    "validation.nationalId.sa.format": "ID must be exactly 10 digits",
    "validation.nationalId.sa.national_id_start": "Saudi National ID must start with 1",
    "validation.nationalId.sa.iqama_start": "Iqama / Residency number must start with 2",
    "validation.nationalId.eg.format": "Egyptian National ID must be exactly 14 digits",
    "validation.nationalId.eg.invalid": "Egyptian National ID has an invalid date or century digit",
    "national_id": "National ID",
    "iqama": "Iqama",
    "passport": "Passport",
    "visa": "VISA",
    "border_number": "Border Number",
    "displaced_person": "Displaced Person",
    "other": "Other",
    "residency": "Iqama",
    "driver_license": "Other",
    "OTHER": "Other",
    male: "Male",
    female: "Female",
    married: "Married",
    single: "Single",
    divorced: "Divorced",
    separated: "Separated",
    widowed: "Widowed",
    msg_quantity_validation_error_title: "DHS Submission Blocked",
    msg_quantity_validation_error: "DHS Dental requires every submitted operation to have a quantity of 1. The following operations must have their quantity set to 1 before submitting:",
    msg_mixed_branch_validation_error_title: "DHS Submission Blocked",
    msg_mixed_branch_validation_error: "All submitted operations must belong to the same branch, because the claim is filed under the branch that rendered the service. The selected operations belong to different branches:",
    msg_group_teeth_validation_error_title: "DHS Submission Blocked",
    msg_group_teeth_validation_error: "DHS rejects services assigned to multiple teeth. The following operations must be split by tooth before submitting:",
    msg_arch_tooth_validation_error_title: "DHS Submission Blocked",
    msg_arch_tooth_validation_error: "NPHIES requires a tooth number in FDI notation. Whole-arch and full-mouth services have no FDI equivalent and cannot be submitted. The following operations must be assigned to a specific tooth before submitting:",
    label_tooth_number: "Tooth #"
  },
  ckb: {
    btn_get_approval: "وەرگرتنی ڕەزامەندی",
    msg_select_operations_first: "تکایە سەرەتا کارەکان هەڵبژێرە",
    msg_branch_missing: "ناسنامەی لق (Branch ID) نییە",
    msg_approval_success: "داواکاری ڕەزامەندی بە سەرکەوتوویی نێردرا",
    msg_approval_failed: "ناردن سەرکەوتوو نەبوو",
    msg_operations_no_longer_submittable: "ئەم کردارانە چیتر ناتوانرێن بنێردرێن. ئەم پەنجەرەیە دابخە و دۆخیان بپشکنە.",
    modal_title: "ناردنی ڕەزامەندی DHS",
    btn_cancel: "پاشگەزبوونەوە",
    btn_submit: "ناردن",
    btn_previous: "پێشوو",
    btn_next: "دواتر",
    step_general: "گشتی",
    step_practitioner: "پزیشک/پسپۆڕ",
    step_diagnosis: "دەستنیشانکردنی نەخۆشی",
    step_attachments: "هاوپێچەکان",
    label_visit_reason: "هۆکاری سەردان",
    label_transaction_type: "جۆری مامەڵە",
    label_claim_request_type: "جۆری داواکاری پێشوەختەی داواکاری (Claim)",
    label_priority: "گرنگی (Priority)",
    label_encounter_status: "بارودۆخی بینین",
    label_encounter_class: "پۆلی بینین",
    label_service_event_type: "جۆری ڕووداوی خزمەتگوزاری",
    label_triage_category: "پۆلێنی پشکنینی سەرەتایی (Triage)",
    label_triage_date: "بەرواری پشکنینی سەرەتایی",
    label_intended_length: "ماوەی مانەوەی مەبەست",
    label_practitioner_name: "ناوی پزیشک/پسپۆڕ",
    label_scfhs: "SCFHS",
    label_speciality_code: "کۆدی پسپۆڕی",
    label_speciality_name: "ناوی پسپۆڕی",
    label_diagnosis_type: "جۆری دەستنیشانکردن",
    label_diagnosis_code: "کۆدی دەستنیشانکردن",
    label_diagnosis_description: "وەسفی دەستنیشانکردن",
    label_chief_complaint: "سکاڵای سەرەکی نەخۆش",
    label_investigation_result: "ئەنجامی پشکنینەکان",
    label_treatment_plan: "پلانی چارەسەر",
    label_patient_history: "مێژووی نەخۆش",
    label_physical_examination: "پشکنینی جەستەیی",
    label_history_present_illness: "مێژووی نەخۆشیی ئێستا",
    btn_add_diagnosis: "زیادکردنی دەستنیشانکردن",
    btn_remove: "سڕینەوە",
    msg_unsupported_file: "لەلایەن Nphies پاڵپشتی ناکرێت",
    msg_file_type_required: "هەڵبژاردنی جۆری فایل پێویستە",
    placeholder_select_file_type: "جۆری فایل هەڵبژێرە",
    required: "پێویستە",
    step_patient_info: "زانیاری نەخۆش",
    step_request_info: "زانیاری داواکاری",
    step_encounter_info: "زانیاری بینین",
    btn_use_code: 'ئەم کۆدە بەکاربهێنە',
    msg_no_diagnosis_found: 'هیچ تەشخیسێک نەدۆزرایەوە. کۆدێک بنووسە بۆ داخڵکردنی دەستی.',
    step_services: "خزمەتگوزارییەکان",
    step_review: "پێداچوونەوە",
    title_patient_information: "زانیارییەکانی نەخۆش",
    label_marital_status: "باری خێزانی",
    label_date_of_birth: "بەرواری لەدایکبوون",
    label_gender: "ڕەگەز",
    label_occupation: "پیشە",
    label_identifier_type: "جۆری ناسنامە",
    label_identifier_id: "ژمارەی ناسنامە",
    label_membership_number: "ژمارەی ئەندامییەتی",
    "auth.nameLength": "ناسنامە ناتوانێت لە ١٠٠ پیت زیاتر بێت",
    label_policy_number: "ژمارەی پۆڵیسە",
    label_policy_holder_name: "ناوی خاوەن پۆڵیسە",
    label_class_name: "پۆلی پۆڵیسە",
    title_claim_preauth_request: "داواکاری پێشوەختەی داواکاری (Claim)",
    label_is_transferal: "ئایا گواستنەوەیە؟",
    title_encounter_details: "وردەکارییەکانی بینین",
    label_admission_date: "بەرواری وەرگرتن",
    label_discharge_date: "بەرواری دەرچوون",
    msg_discharge_date_error: "پێویستە بەرواری دەرچوون دوای یان یەکسان بێت بە بەرواری وەرگرتن",
    msg_admission_date_error: "بەرواری پەسەندکردن ناتوانێ دوای زووترین بەرواری خزمەتگوزاری بێت",
    msg_discharge_date_service_error: "بەرواری بەرەوچوون ناتوانێ پێش دواترین بەرواری خزمەتگوزاری بێت",
    placeholder_search_practitioner: "گەڕان بۆ پزیشک/پسپۆڕ",
    label_scfhs_license: "مۆڵەتی SCFHS",
    title_diagnosis_information: "زانیاری دەستنیشانکردنی نەخۆشی",
    msg_missing_code: "کۆد نییە",
    msg_missing_type: "جۆر نییە",
    msg_at_least_one_diagnosis: "بە لایەنی کەم دەستنیشانکردنێک پێویستە",
    label_code: "کۆد",
    label_type: "جۆر",
    label_description: "وەسف",
    title_medical_details: "وردەکارییە پزیشکییەکان",
    title_services_procedures: "خزمەتگوزارییەکان / ڕێکارەکان",
    label_service_code: "کۆدی خزمەتگوزاری",
    label_quantity: "بڕ",
    label_branch: "لق",
    label_unit_price: "نرخی یەکە",
    label_vat_percentage: "ڕێژەی باج %",
    label_discount_percentage: "ڕێژەی داشکاندن %",
    label_discount_amount: "بڕی داشکاندن",
    label_vat_amount: "بڕی باج (١٥٪)",
    msg_vat_calculated_auto: "بە شێوەیەکی ئۆتۆماتیکی بە ڕێژەی ١٥٪ دوای داشکاندن هەژمار دەکرێت",
    label_service_type: "جۆری خزمەتگوزاری",
    title_attachments: "هاوپێچەکان",
    title_supported_file_formats: "جۆرە فایلە ڕێپێدراوەکان",
    desc_supported_file_formats: "تکایە تێبینی بکە کە تەنها فایلەکانی PDF, JPEG, JPG, و PNG بۆ ڕەزامەندییەکانی DHS ڕێپێدراون.",
    label_include: "لەخۆگرتن",
    label_file_name: "ناوی فایل",
    label_content_type: "جۆری ناوەڕۆک",
    label_file_type: "جۆری فایل",
    label_unknown: "نەزانراو",
    msg_unsupported_file_format: "جۆری فایل ڕێپێدراو نییە",
    label_view: "بینین",
    title_review_submit: "پێداچوونەوە و ناردن",
    title_diagnosis_medical_details: "دەستنیشانکردن و وردەکاری پزیشکی",
    label_name: "ناو",
    label_status: "بارودۆخ",
    label_qty: "بڕ",
    label_yes: "بەڵێ",
    label_no: "نەخێر",
    relatedApprovalNumber: "ژمارەی ڕەزامەندی پەیوەندیدار",
    relatedApprovalRequired: "ژمارەی ڕەزامەندی پەیوەندیدار پێویستە",
    "validation.nationalId.sa.format": "پێویستە ژمارەی ناسنامە ڕێک ١٠ ژمارە بێت",
    "validation.nationalId.sa.national_id_start": "ناسنامەی نیشتمانی سعودی دەبێت بە ١ دەست پێ بکات",
    "validation.nationalId.sa.iqama_start": "ژمارەی ئیقامە / نیشتەجێبوون دەبێت بە ٢ دەست پێ بکات",
    "validation.nationalId.eg.format": "ناسنامەی نیشتمانی میسری دەبێت ڕێک ١٤ ژمارە بێت",
    "validation.nationalId.eg.invalid": "ناسنامەی نیشتمانی میسری بەروار یان سەدەی نادروستی تێدایە",
    "national_id": "ناسنامەی نیشتمانی",
    "iqama": "ئیقامە",
    "passport": "پاسپۆرت",
    "visa": "ڤیزا",
    "border_number": "ژمارەی سنوور",
    "displaced_person": "کەسی ئاوارە",
    "other": "تر",
    "residency": "ئیقامە",
    "driver_license": "تر",
    "OTHER": "تر",
    male: "نێر",
    female: "مێ",
    married: "هاوسەردار",
    single: "سەڵت",
    divorced: "جیابووەوە",
    separated: "جیاواز",
    widowed: "بێوەژن/بێوەپیاو",
    msg_quantity_validation_error_title: "ناردنی DHS بەستراوەتەوە",
    msg_quantity_validation_error: "DHS ی ددان پێویستی بەوەیە کە هەر کارێکی نێردراو بڕی ١ بێت. دەبێت بڕی ئەم کارانەی خوارەوە پێش ناردن بگۆڕدرێت بۆ ١:",
    msg_mixed_branch_validation_error_title: "ناردنی DHS بەستراوەتەوە",
    msg_mixed_branch_validation_error: "دەبێت هەموو کارە نێردراوەکان سەر بە هەمان لق بن، چونکە داواکارییەکە بە ناوی ئەو لقەوە تۆمار دەکرێت کە خزمەتگوزارییەکەی پێشکەش کردووە. کارە هەڵبژێردراوەکان سەر بە لقی جیاوازن:",
    msg_group_teeth_validation_error_title: "ناردنی DHS بەستراوەتەوە",
    msg_group_teeth_validation_error: "DHS خزمەتگوزاریەکانی دیاریکراو بۆ چەندین ددان ڕەتدەکاتەوە. ئەم مەلبەندانەی خوارەوە دەبێت پێش ناردن بە پێی ددان دابەش بکرێن:",
    msg_arch_tooth_validation_error_title: "ناردنی DHS بەستراوەتەوە",
    msg_arch_tooth_validation_error: "NPHIES پێویستی بە ژمارەی ددانە بە شێوازی FDI. ئەو خزمەتگوزارییانەی بۆ هەموو کەوانە یان هەموو دەمن هاوتای FDI یان نییە و ناتوانرێن بنێردرێن. پێویستە ئەم کردارانە پێش ناردن بۆ ددانێکی دیاریکراو دیاری بکرێن:",
    label_tooth_number: "ددان #"    

  },
  el: {
    btn_get_approval: "Λήψη έγκρισης",
    msg_select_operations_first: "Παρακαλώ επιλέξτε πρώτα τις λειτουργίες",
    msg_branch_missing: "Λείπει το ID υποκαταστήματος",
    msg_approval_success: "Η έγκριση υποβλήθηκε με επιτυχία",
    msg_approval_failed: "Η υποβολή απέτυχε",
    msg_operations_no_longer_submittable: "Αυτές οι πράξεις δεν μπορούν πλέον να υποβληθούν. Κλείστε αυτό το παράθυρο και ελέγξτε την κατάστασή τους.",
    modal_title: "Υποβολή έγκρισης DHS",
    btn_cancel: "Ακύρωση",
    btn_submit: "Υποβολή",
    btn_previous: "Προηγούμενο",
    btn_next: "Επόμενο",
    step_general: "Γενικά",
    step_practitioner: "Επαγγελματίας υγείας",
    step_diagnosis: "Διάγνωση",
    step_attachments: "Συνημμένα",
    label_visit_reason: "Αιτία επίσκεψης",
    label_transaction_type: "Τύπος συναλλαγής",
    label_claim_request_type: "Τύπος αιτήματος προέγκρισης",
    label_priority: "Προτεραιότητα",
    label_encounter_status: "Κατάσταση περιστατικού",
    label_encounter_class: "Κατηγορία περιστατικού",
    label_service_event_type: "Τύπος συμβάντος υπηρεσίας",
    label_triage_category: "Κατηγορία διαλογής",
    label_triage_date: "Ημερομηνία διαλογής",
    label_intended_length: "Προβλεπόμενη διάρκεια παραμονής",
    label_practitioner_name: "Όνομα ιατρού",
    label_scfhs: "SCFHS",
    label_speciality_code: "Κωδικός ειδικότητας",
    label_speciality_name: "Όνομα ειδικότητας",
    label_diagnosis_type: "Τύπος διάγνωσης",
    label_diagnosis_code: "Κωδικός διάγνωσης",
    label_diagnosis_description: "Περιγραφή διάγνωσης",
    label_chief_complaint: "Κύρια ενόχληση",
    label_investigation_result: "Αποτέλεσμα έρευνας",
    label_treatment_plan: "Σχέδιο θεραπείας",
    label_patient_history: "Ιστορικό ασθενούς",
    label_physical_examination: "Φυσική εξέταση",
    label_history_present_illness: "Ιστορικό παρούσας νόσου",
    btn_add_diagnosis: "Προσθήκη διάγνωσης",
    btn_remove: "Αφαίρεση",
    msg_unsupported_file: "Δεν υποστηρίζεται από το Nphies",
    msg_file_type_required: "Η επιλογή τύπου αρχείου είναι υποχρεωτική",
    placeholder_select_file_type: "Επιλέξτε τύπο αρχείου",
    required: "Απαιτείται",
    step_patient_info: "Πληροφορίες Ασθενούς",
    step_request_info: "Πληροφορίες Αιτήματος",
    step_encounter_info: "Πληροφορίες Περιστατικού",
    btn_use_code: 'Χρησιμοποιήστε αυτόν τον κωδικό',
    msg_no_diagnosis_found: 'Δεν βρέθηκε διάγνωση. Πληκτρολογήστε κωδικό για χειροκίνητη εισαγωγή.',
    step_services: "Υπηρεσίες",
    step_review: "Επισκόπηση",
    title_patient_information: "Πληροφορίες Ασθενούς",
    label_marital_status: "Οικογενειακή Κατάσταση",
    label_date_of_birth: "Ημερομηνία Μηλαγματούς",
    label_gender: "Φύλο",
    label_occupation: "Επάγγελμα",
    label_identifier_type: "Τύπος Αναγνωριστικού",
    label_identifier_id: "ID Αναγνωριστικού",
    label_membership_number: "Αριθμός Μέλους",
    "auth.nameLength": "Ο αριθμός ταυτότητας δεν μπορεί να υπερβαίνει τους 100 χαρακτήρες",
    label_policy_number: "Αριθμός Συμβολαίου",
    label_policy_holder_name: "Όνομα Κατόχου Συμβολαίου",
    label_class_name: "Κατηγορία Συμβολαίου",
    title_claim_preauth_request: "Αίτημα Προέγκρισης Απαίτησης",
    label_is_transferal: "Είναι Μεταφορά",
    title_encounter_details: "Λεπτομέρειες Περιστατικού",
    label_admission_date: "Ημερομηνία Εισαγωγής",
    label_discharge_date: "Ημερομηνία Εξιτηρίου",
    msg_discharge_date_error: "Η ημερομηνία εξιτηρίου πρέπει να είναι μεταγενέστερη ή ίση με την εισαγωγή",
    msg_admission_date_error: "Η ημερομηνία εισαγωγής δεν μπορεί να είναι μετά την πρώτη ημερομηνία υπηρεσίας",
    msg_discharge_date_service_error: "Η ημερομηνία εξόδου δεν μπορεί να είναι πριν από την τελευταία ημερομηνία υπηρεσίας",
    placeholder_search_practitioner: "Αναζήτηση ιατρού",
    label_scfhs_license: "Άδεια SCFHS",
    title_diagnosis_information: "Πληροφορίες Διάγνωσης",
    msg_missing_code: "Λείπει ο κωδικός",
    msg_missing_type: "Λείπει ο τύπος",
    msg_at_least_one_diagnosis: "Απαιτείται τουλάχιστον μία διάγνωση",
    label_code: "Κωδικός",
    label_type: "Τύπος",
    label_description: "Περιγραφή",
    title_medical_details: "Ιατρικές Λεπτομέρειες",
    title_services_procedures: "Υπηρεσίες / Διαδικασίες",
    label_service_code: "Κωδικός Υπηρεσίας",
    label_quantity: "Ποσότητα",
    label_branch: "Υποκατάστημα",
    label_unit_price: "Τιμή Μονάδας",
    label_vat_percentage: "ΦΠΑ %",
    label_discount_percentage: "Έκπτωση %",
    label_discount_amount: "Ποσό Έκπτωσης",
    label_vat_amount: "Ποσό ΦΠΑ (15%)",
    msg_vat_calculated_auto: "Υπολογίζεται αυτόματα σε 15% μετά την έκπτωση",
    label_service_type: "Τύπος Υπηρεσίας",
    title_attachments: "Συνημμένα",
    title_supported_file_formats: "Υποστηριζόμενες Μορφές Αρχείων",
    desc_supported_file_formats: "Σημειώστε ότι μόνο αρχεία PDF, JPEG, JPG και PNG υποστηρίζονται για εγκρίσεις DHS.",
    label_include: "Συμπερίληψη",
    label_file_name: "Όνομα Αρχείου",
    label_content_type: "Τύπος Περιεχομένου",
    label_file_type: "Τύπος Αρχείου",
    label_unknown: "Άγνωστο",
    msg_unsupported_file_format: "Μη υποστηριζόμενη μορφή αρχείου",
    label_view: "Προβολή",
    title_review_submit: "Επισκόπηση & Υποβολή",
    title_diagnosis_medical_details: "Διάγνωση & Ιατρικές Λεπτομέρειες",
    label_name: "Όνομα",
    label_status: "Κατάσταση",
    label_qty: "Ποσ.",
    label_yes: "Ναι",
    label_no: "Όχι",
    relatedApprovalNumber: "Σχετικός αριθμός έγκρισης",
    relatedApprovalRequired: "Απαιτείται ο σχετικός αριθμός έγκρισης",
    "validation.nationalId.sa.format": "Η ταυτότητα πρέπει να είναι ακριβώς 10 ψηφία",
    "validation.nationalId.sa.national_id_start": "Η εθνική ταυτότητα της Σαουδικής Αραβίας πρέπει να ξεκινά με 1",
    "validation.nationalId.sa.iqama_start": "Ο αριθμός Iqama / διαμονής πρέπει να ξεκινά με 2",
    "validation.nationalId.eg.format": "Η αιγυπτιακή εθνική ταυτότητα πρέπει να είναι ακριβώς 14 ψηφία",
    "validation.nationalId.eg.invalid": "Η αιγυπτιακή εθνική ταυτότητα έχει μη έγκυρη ημερομηνία ή αιώνα",
    "national_id": "Εθνική ταυτότητα",
    "iqama": "Iqama",
    "passport": "Διαβατήριο",
    "visa": "Βίζα",
    "border_number": "Αριθμός συνόρων",
    "displaced_person": "Εκτοπισμένο άτομο",
    "other": "Άλλο",
    "residency": "Iqama",
    "driver_license": "Άλλο",
    "OTHER": "Άλλο",
    male: "Άνδρας",
    female: "Γυναίκα",
    married: "Έγγαμος",
    single: "Άγαμος",
    divorced: "Διαζευγμένος",
    separated: "Σε διάσταση",
    widowed: "Χήρος/α",
    msg_quantity_validation_error_title: "Η υποβολή DHS αποκλείστηκε",
    msg_quantity_validation_error: "Το DHS Dental απαιτεί κάθε υποβαλλόμενη εργασία να έχει ποσότητα 1. Οι παρακάτω εργασίες πρέπει να έχουν ποσότητα 1 πριν την υποβολή:",
    msg_mixed_branch_validation_error_title: "Η υποβολή DHS αποκλείστηκε",
    msg_mixed_branch_validation_error: "Όλες οι υποβαλλόμενες εργασίες πρέπει να ανήκουν στο ίδιο υποκατάστημα, καθώς η αίτηση υποβάλλεται από το υποκατάστημα που παρείχε την υπηρεσία. Οι επιλεγμένες εργασίες ανήκουν σε διαφορετικά υποκαταστήματα:",
    msg_group_teeth_validation_error_title: "Η υποβολή DHS αποκλείστηκε",
    msg_group_teeth_validation_error: "Το DHS απορρίπτει υπηρεσίες που έχουν ανατεθεί σε πολλά δόντια. Οι παρακάτω εργασίες πρέπει να χωριστούν ανά δόντι πριν την υποβολή:",
    msg_arch_tooth_validation_error_title: "Η υποβολή DHS αποκλείστηκε",
    msg_arch_tooth_validation_error: "Το NPHIES απαιτεί αριθμό δοντιού σε σημειογραφία FDI. Οι υπηρεσίες που αφορούν ολόκληρο το τόξο ή όλο το στόμα δεν έχουν αντίστοιχο FDI και δεν μπορούν να υποβληθούν. Οι παρακάτω εργασίες πρέπει να ανατεθούν σε συγκεκριμένο δόντι πριν από την υποβολή:",
    label_tooth_number: "Δόντι #"    
  },
  fr: {
    btn_get_approval: "Obtenir l'approbation",
    msg_select_operations_first: "Veuillez d'abord sélectionner les opérations",
    msg_branch_missing: "L'ID de la succursale est manquant",
    msg_approval_success: "Approbation soumise avec succès",
    msg_approval_failed: "Échec de la soumission",
    msg_operations_no_longer_submittable: "Ces actes ne peuvent plus être envoyés. Fermez cette fenêtre et vérifiez leur statut.",
    modal_title: "Soumission d'approbation DHS",
    btn_cancel: "Annuler",
    btn_submit: "Soumettre",
    btn_previous: "Précédent",
    btn_next: "Suivant",
    step_general: "Général",
    step_practitioner: "Praticien",
    step_diagnosis: "Diagnostic",
    step_attachments: "Pièces jointes",
    label_visit_reason: "Motif de la visite",
    label_transaction_type: "Type de transaction",
    label_claim_request_type: "Type de demande d'autorisation préalable",
    label_priority: "Priorité",
    label_encounter_status: "Statut de la rencontre",
    label_encounter_class: "Classe de la rencontre",
    label_service_event_type: "Type d'événement de service",
    label_triage_category: "Catégorie de triage",
    label_triage_date: "Date de triage",
    label_intended_length: "Durée prévue du séjour",
    label_practitioner_name: "Nom du praticien",
    label_scfhs: "SCFHS",
    label_speciality_code: "Code de spécialité",
    label_speciality_name: "Nom de la spécialité",
    label_diagnosis_type: "Type de diagnostic",
    label_diagnosis_code: "Code de diagnostic",
    label_diagnosis_description: "Description du diagnostic",
    label_chief_complaint: "Motif principal",
    label_investigation_result: "Résultat de l'investigation",
    label_treatment_plan: "Plan de traitement",
    label_patient_history: "Antécédents du patient",
    label_physical_examination: "Examen physique",
    label_history_present_illness: "Histoire de la maladie actuelle",
    btn_add_diagnosis: "Ajouter un diagnostic",
    btn_remove: "Supprimer",
    msg_unsupported_file: "Non supporté par Nphies",
    msg_file_type_required: "La sélection du type de fichier est requise",
    placeholder_select_file_type: "Sélectionnez le type de fichier",
    required: "Requis",
    step_patient_info: "Infos Patient",
    step_request_info: "Infos Demande",
    step_encounter_info: "Infos Rencontre",
    btn_use_code: 'Utiliser ce code',
    msg_no_diagnosis_found: 'Aucun diagnostic trouvé. Tapez un code pour saisir manuellement.',
    step_services: "Services",
    step_review: "Révision",
    title_patient_information: "Informations sur le Patient",
    label_marital_status: "État Civil",
    label_date_of_birth: "Date de naissance",
    label_gender: "Genre",
    label_occupation: "Occupation",
    label_identifier_type: "Type d'identifiant",
    label_identifier_id: "ID de l'identifiant",
    label_membership_number: "Numéro d'adhérent",
    "auth.nameLength": "L'identifiant ne peut pas dépasser 100 caractères",
    label_policy_number: "Numéro de police",
    label_policy_holder_name: "Nom du titulaire",
    label_class_name: "Classe de police",
    title_claim_preauth_request: "Demande d'autorisation préalable",
    label_is_transferal: "Est un transfert",
    title_encounter_details: "Détails de la rencontre",
    label_admission_date: "Date d'admission",
    label_discharge_date: "Date de sortie",
    msg_discharge_date_error: "La date de sortie doit être postérieure ou égale à la date d'admission",
    msg_admission_date_error: "La date d'admission ne peut pas être postérieure à la date de service la plus ancienne",
    msg_discharge_date_service_error: "La date de sortie ne peut pas être antérieure à la date de service la plus récente",
    placeholder_search_practitioner: "Rechercher un praticien",
    label_scfhs_license: "Licence SCFHS",
    title_diagnosis_information: "Informations sur le diagnostic",
    msg_missing_code: "Code manquant",
    msg_missing_type: "Type manquant",
    msg_at_least_one_diagnosis: "Au moins un diagnostic est requis",
    label_code: "Code",
    label_type: "Type",
    label_description: "Description",
    title_medical_details: "Détails médicaux",
    title_services_procedures: "Services / Procédures",
    label_service_code: "Code de service",
    label_quantity: "Quantité",
    label_branch: "Succursale",
    label_unit_price: "Prix unitaire",
    label_vat_percentage: "TVA %",
    label_discount_percentage: "Remise %",
    label_discount_amount: "Montant de la remise",
    label_vat_amount: "Montant de la TVA (15%)",
    msg_vat_calculated_auto: "Calculé automatiquement à 15% après remise",
    label_service_type: "Type de service",
    title_attachments: "Pièces jointes",
    title_supported_file_formats: "Formats de fichiers supportés",
    desc_supported_file_formats: "Seuls les fichiers PDF, JPEG, JPG et PNG sont supportés pour les approbations DHS.",
    label_include: "Inclure",
    label_file_name: "Nom du fichier",
    label_content_type: "Type de contenu",
    label_file_type: "Type de fichier",
    label_unknown: "Inconnu",
    msg_unsupported_file_format: "Format de fichier non supporté",
    label_view: "Voir",
    title_review_submit: "Réviser & Soumettre",
    title_diagnosis_medical_details: "Diagnostic & Détails Médicaux",
    label_name: "Nom",
    label_status: "Statut",
    label_qty: "Qté",
    label_yes: "Oui",
    label_no: "Non",
    relatedApprovalNumber: "Numéro d'approbation associé",
    relatedApprovalRequired: "Le numéro d'approbation associé est requis",
    "validation.nationalId.sa.format": "La carte d'identité doit comporter exactement 10 chiffres",
    "validation.nationalId.sa.national_id_start": "La carte d'identité nationale saoudienne doit commencer par 1",
    "validation.nationalId.sa.iqama_start": "Le numéro de l'Iqama / résidence doit commencer par 2",
    "validation.nationalId.eg.format": "La carte d'identité nationale égyptienne doit comporter exactement 14 chiffres",
    "validation.nationalId.eg.invalid": "La carte d'identité nationale égyptienne a une date ou un siècle invalide",
    "national_id": "Carte d'identité nationale",
    "iqama": "Iqama",
    "passport": "Passeport",
    "visa": "VISA",
    "border_number": "Numéro de frontière",
    "displaced_person": "Personne déplacée",
    "other": "Autre",
    "residency": "Iqama",
    "driver_license": "Autre",
    "OTHER": "Autre",
    male: "Homme",
    female: "Femme",
    married: "Marié(e)",
    single: "Célibataire",
    divorced: "Divorcé(e)",
    separated: "Séparé(e)",
    widowed: "Veuf/Veuve",
    msg_quantity_validation_error_title: "Soumission DHS bloquée",
    msg_quantity_validation_error: "DHS Dental exige que chaque opération soumise ait une quantité de 1. Les opérations suivantes doivent avoir une quantité de 1 avant soumission:",
    msg_mixed_branch_validation_error_title: "Soumission DHS bloquée",
    msg_mixed_branch_validation_error: "Toutes les opérations soumises doivent appartenir à la même succursale, car la demande est déposée au nom de la succursale ayant fourni le service. Les opérations sélectionnées appartiennent à des succursales différentes:",
    msg_group_teeth_validation_error_title: "Soumission DHS bloquée",
    msg_group_teeth_validation_error: "DHS rejette les services assignés à plusieurs dents. Les opérations suivantes doivent être divisées par dent avant soumission:",
    msg_arch_tooth_validation_error_title: "Soumission DHS bloquée",
    msg_arch_tooth_validation_error: "NPHIES exige un numéro de dent en notation FDI. Les services portant sur une arcade entière ou sur la bouche entière n'ont pas d'équivalent FDI et ne peuvent pas être soumis. Les opérations suivantes doivent être affectées à une dent précise avant la soumission :",
    label_tooth_number: "Dent n°"    
  },
  it: {
    btn_get_approval: "Ottieni approvazione",
    msg_select_operations_first: "Selezionare prima le operazioni",
    msg_branch_missing: "ID filiale mancante",
    msg_approval_success: "Approvazione inviata con successo",
    msg_approval_failed: "Invio fallito",
    msg_operations_no_longer_submittable: "Queste prestazioni non possono più essere inviate. Chiudi questa finestra e verificane lo stato.",
    modal_title: "Invio approvazione DHS",
    btn_cancel: "Annulla",
    btn_submit: "Invia",
    btn_previous: "Precedente",
    btn_next: "Successivo",
    step_general: "Generale",
    step_practitioner: "Medico",
    step_diagnosis: "Diagnosi",
    step_attachments: "Allegati",
    label_visit_reason: "Motivo della visita",
    label_transaction_type: "Tipo di transazione",
    label_claim_request_type: "Tipo richiesta preautorizzazione",
    label_priority: "Priorità",
    label_encounter_status: "Stato incontro",
    label_encounter_class: "Classe incontro",
    label_service_event_type: "Tipo evento servizio",
    label_triage_category: "Categoria triage",
    label_triage_date: "Data triage",
    label_intended_length: "Durata prevista della degenza",
    label_practitioner_name: "Nome medico",
    label_scfhs: "SCFHS",
    label_speciality_code: "Codice specialità",
    label_speciality_name: "Nome specialità",
    label_diagnosis_type: "Tipo diagnosi",
    label_diagnosis_code: "Codice diagnosi",
    label_diagnosis_description: "Descrizione diagnosi",
    label_chief_complaint: "Sintomo principale",
    label_investigation_result: "Risultato indagine",
    label_treatment_plan: "Piano di trattamento",
    label_patient_history: "Anamnesi paziente",
    label_physical_examination: "Esame obiettivo",
    label_history_present_illness: "Anamnesi patologica prossima",
    btn_add_diagnosis: "Aggiungi diagnosi",
    btn_remove: "Rimuovi",
    msg_unsupported_file: "Non supportato da Nphies",
    msg_file_type_required: "La selezione del tipo di file è obbligatoria",
    placeholder_select_file_type: "Seleziona tipo di file",
    required: "Obbligatorio",
    step_patient_info: "Info Paziente",
    step_request_info: "Info Richiesta",
    step_encounter_info: "Info Incontro",
    btn_use_code: 'Usa questo codice',
    msg_no_diagnosis_found: 'Nessuna diagnosi trovata. Digita un codice per inserire manualmente.',
    step_services: "Servizi",
    step_review: "Riepilogo",
    title_patient_information: "Informazioni Paziente",
    label_marital_status: "Stato Civile",
    label_date_of_birth: "Data Nascita",
    label_gender: "Genere",
    label_occupation: "Occupazione",
    label_identifier_type: "Tipo Identificativo",
    label_identifier_id: "ID Identificativo",
    label_membership_number: "Numero Socio",
    "auth.nameLength": "L'identificativo non può superare i 100 caratteri",
    label_policy_number: "Numero Polizza",
    label_policy_holder_name: "Nome Contraente",
    label_class_name: "Classe Polizza",
    title_claim_preauth_request: "Richiesta Preautorizzazione",
    label_is_transferal: "È un trasferimento",
    title_encounter_details: "Dettagli Incontro",
    label_admission_date: "Data Ammissione",
    label_discharge_date: "Data Dimissione",
    msg_discharge_date_error: "La data di dimissione deve essere successiva o uguale alla data di ammissione",
    msg_admission_date_error: "La data di ammissione non può essere successiva alla prima data del servizio",
    msg_discharge_date_service_error: "La data di dimissione non può essere precedente all'ultima data del servizio",
    placeholder_search_practitioner: "Cerca medico",
    label_scfhs_license: "Licenza SCFHS",
    title_diagnosis_information: "Informazioni Diagnosi",
    msg_missing_code: "Codice mancante",
    msg_missing_type: "Tipo mancante",
    msg_at_least_one_diagnosis: "È richiesta almeno una diagnosi",
    label_code: "Codice",
    label_type: "Tipo",
    label_description: "Descrizione",
    title_medical_details: "Dettagli Medici",
    title_services_procedures: "Servizi / Procedure",
    label_service_code: "Codice Servizio",
    label_quantity: "Quantità",
    label_branch: "Filiale",
    label_unit_price: "Prezzo Unitario",
    label_vat_percentage: "IVA %",
    label_discount_percentage: "Sconto %",
    label_discount_amount: "Importo Sconto",
    label_vat_amount: "Importo IVA (15%)",
    msg_vat_calculated_auto: "Calcolato automaticamente al 15% dopo lo sconto",
    label_service_type: "Tipo Servizio",
    title_attachments: "Allegati",
    title_supported_file_formats: "Formati File Supportati",
    desc_supported_file_formats: "Si prega di notare che solo i file PDF, JPEG, JPG e PNG sono supportati per le approvazioni DHS.",
    label_include: "Includi",
    label_file_name: "Nome File",
    label_content_type: "Tipo Contenuto",
    label_file_type: "Tipo File",
    label_unknown: "Sconosciuto",
    msg_unsupported_file_format: "Formato file non supportato",
    label_view: "Visualizza",
    title_review_submit: "Rivedi e Invia",
    title_diagnosis_medical_details: "Diagnosi e Dettagli Medici",
    label_name: "Nome",
    label_status: "Stato",
    label_qty: "Qtà",
    label_yes: "Sì",
    label_no: "No",
    relatedApprovalNumber: "Numero di approvazione correlato",
    relatedApprovalRequired: "Il numero di approvazione correlato è obbligatorio",
    "validation.nationalId.sa.format": "L'ID deve contenere esattamente 10 cifre",
    "validation.nationalId.sa.national_id_start": "L'ID nazionale saudita deve iniziare con 1",
    "validation.nationalId.sa.iqama_start": "Il numero Iqama / di residenza deve iniziare con 2",
    "validation.nationalId.eg.format": "L'ID nazionale egiziano deve contenere esattamente 14 cifre",
    "validation.nationalId.eg.invalid": "L'ID nazionale egiziano ha una data o un secolo non validi",
    "national_id": "ID nazionale",
    "iqama": "Iqama",
    "passport": "Passaporto",
    "visa": "Visto",
    "border_number": "Numero di confine",
    "displaced_person": "Persona sfollata",
    "other": "Altro",
    "residency": "Iqama",
    "driver_license": "Altro",
    "OTHER": "Altro",
    male: "Maschio",
    female: "Femmina",
    married: "Sposato/a",
    single: "Celibe/Nubile",
    divorced: "Divorziato/a",
    separated: "Separato/a",
    widowed: "Vedovo/a",
    msg_quantity_validation_error_title: "Invio DHS bloccato",
    msg_quantity_validation_error: "DHS Dental richiede che ogni operazione inviata abbia quantità 1. Le seguenti operazioni devono avere quantità 1 prima dell'invio:",
    msg_mixed_branch_validation_error_title: "Invio DHS bloccato",
    msg_mixed_branch_validation_error: "Tutte le operazioni inviate devono appartenere alla stessa filiale, poiché la richiesta è presentata a nome della filiale che ha erogato il servizio. Le operazioni selezionate appartengono a filiali diverse:",
    msg_group_teeth_validation_error_title: "Invio DHS bloccato",
    msg_group_teeth_validation_error: "DHS rifiuta i servizi assegnati a più denti. Le seguenti operazioni devono essere suddivise per dente prima dell'invio:",
    msg_arch_tooth_validation_error_title: "Invio DHS bloccato",
    msg_arch_tooth_validation_error: "NPHIES richiede un numero di dente in notazione FDI. I servizi riferiti all'intera arcata o all'intera bocca non hanno un equivalente FDI e non possono essere inviati. Le seguenti operazioni devono essere assegnate a un dente specifico prima dell'invio:",
    label_tooth_number: "Dente n."    
  },
  ku: {
    btn_get_approval: "Pesendkirinê bistîne",
    msg_select_operations_first: "Ji kerema xwe pêşî operasyonan hilbijêrin",
    msg_branch_missing: "Nasnameya şaxê (Branch ID) kêm e",
    msg_approval_success: "Daxwaza pesendkirinê bi serkeftî hat şandin",
    msg_approval_failed: "Şandin bi ser neket",
    msg_operations_no_longer_submittable: "Ev kar êdî nayên şandin. Vê pencereyê bigire û rewşa wan kontrol bike.",
    modal_title: "Şandina pesendkirina DHS",
    btn_cancel: "Betal bike",
    btn_submit: "Bişîne",
    btn_previous: "Berê",
    btn_next: "Piştî",
    step_general: "Giştî",
    step_practitioner: "Bijîşk/Pispor",
    step_diagnosis: "Teşhîs (Diagnosis)",
    step_attachments: "Pêvekan",
    label_visit_reason: "Sedema serdanê",
    label_transaction_type: "Cureyê danûstendinê",
    label_claim_request_type: "Cureyê daxwaza pêş-destûra daxwazê",
    label_priority: "Pêşîndarî",
    label_encounter_status: "Rewşa hevdîtinê",
    label_encounter_class: "Pola hevdîtinê",
    label_service_event_type: "Cureyê bûyera xizmetê",
    label_triage_category: "Kategoriya triyajê",
    label_triage_date: "Dîroka triyajê",
    label_intended_length: "Dema mayînê ya tê xwestin",
    label_practitioner_name: "Navê bijîşk/pispor",
    label_scfhs: "SCFHS",
    label_speciality_code: "Koda pisporiyê",
    label_speciality_name: "Navê pisporiyê",
    label_diagnosis_type: "Cureyê teşhîsê",
    label_diagnosis_code: "Koda teşhîsê",
    label_diagnosis_description: "Daxuyaniya teşhîsê",
    label_chief_complaint: "Giliya sereke",
    label_investigation_result: "Encama lêkolînê",
    label_treatment_plan: "Plana dermankirinê",
    label_patient_history: "Dîroka nexweş",
    label_physical_examination: "Kontrola fîzîkî",
    label_history_present_illness: "Dîroka nexweşiya niha",
    btn_add_diagnosis: "Teşhîsê zêde bike",
    btn_remove: "Rake",
    msg_unsupported_file: "Ji hêla Nphies ve nayê piştgirî kirin",
    msg_file_type_required: "Hilbijartina cureyê pelê pêdivî ye",
    placeholder_select_file_type: "Cureyê pelê hilbijêre",
    required: "Pêdivî ye",
    step_patient_info: "Zanyarî Nexweş",
    step_request_info: "Zanyarî Daxwaz",
    step_encounter_info: "Zanyarî Hevdîtin",
    btn_use_code: 'Vê kodê bikar bîne',
    msg_no_diagnosis_found: 'Tiştek nehat dîtin. Kodekê binivîse da ku bi destan têxî.',
    step_services: "Xizmetan",
    step_review: "Kontrolkirin",
    title_patient_information: "Zanyariyên Nexweş",
    label_marital_status: "Rewşa Zewacê",
    label_date_of_birth: "Dîroka Qebûlkirinê",
    label_gender: "Zayend",
    label_occupation: "Pîşe",
    label_identifier_type: "Cureyê Nasnameyê",
    label_identifier_id: "ID ya Nasnameyê",
    label_membership_number: "Hejmara Endamtiyê",
    "auth.nameLength": "Nasname nikare ji 100 tîpan zêdetir be",
    label_policy_number: "Hejmara Polîçeyê",
    label_policy_holder_name: "Navê Xwediyê Polîçeyê",
    label_class_name: "Pola Polîçeyê",
    title_claim_preauth_request: "Daxwaza Pêş-destûrê",
    label_is_transferal: "Guhastin e?",
    title_encounter_details: "Hûrguliyên Hevdîtinê",
    label_admission_date: "Dîroka Qebûlkirinê",
    label_discharge_date: "Dîroka Derketinê",
    msg_discharge_date_error: "Dîroka derketinê divê piştî an wekî dîroka qebûlkirinê be",
    msg_admission_date_error: "Dîroka pejirandinê nikare piştî dîroka xizmeta herî zû be",
    msg_discharge_date_service_error: "Dîroka derketinê nikare berî dîroka xizmeta herî dereng be",
    placeholder_search_practitioner: "Li bijîşk bigere",
    label_scfhs_license: "Lîsansa SCFHS",
    title_diagnosis_information: "Zanyarî Teşhîsê",
    msg_missing_code: "Kod kêm e",
    msg_missing_type: "Cure kêm e",
    msg_at_least_one_diagnosis: "Bi kêmanî teşhîsek pêdivî ye",
    label_code: "Kod",
    label_type: "Cure",
    label_description: "Daxuyanî",
    title_medical_details: "Hûrguliyên Bijîşkî",
    title_services_procedures: "Xizmet / Rêkar",
    label_service_code: "Koda Xizmetê",
    label_quantity: "Hejmar",
    label_branch: "Şax",
    label_unit_price: "Bihayê Yekeyê",
    label_vat_percentage: "Bac %",
    label_discount_percentage: "Daxistin %",
    label_discount_amount: "Mîqdara daxistinê",
    label_vat_amount: "Mîqdara bacê (15%)",
    msg_vat_calculated_auto: "Piştî daxistinê bixweber wekî 15% tê hesibandin",
    label_service_type: "Cureyê Xizmetê",
    title_attachments: "Pêvekan",
    title_supported_file_formats: "Formatên Pelan ên Piştgirî",
    desc_supported_file_formats: "Ji kerema xwe bala xwe bidin ku tenê pelên PDF, JPEG, JPG, û PNG ji bo pesendkirina DHS têne piştgirî kirin.",
    label_include: "Tê de hebe",
    label_file_name: "Navê Pelê",
    label_content_type: "Cureyê Naverokê",
    label_file_type: "Cureyê Pelê",
    label_unknown: "Nenas",
    msg_unsupported_file_format: "Formata pelê nayê piştgirî kirin",
    label_view: "Bibîne",
    title_review_submit: "Kontrol bike & Bişîne",
    title_diagnosis_medical_details: "Teşhîs & Hûrguliyên Bijîşkî",
    label_name: "Nav",
    label_status: "Rewş",
    label_qty: "Hejm",
    label_yes: "Belê",
    label_no: "Na",
    relatedApprovalNumber: "Hejmara pesendkirinê ya têkildar",
    relatedApprovalRequired: "Hejmara pesendkirinê ya têkildar pêdivî ye",
    "validation.nationalId.sa.format": "Divê nasname bi rastî 10 hejmar be",
    "validation.nationalId.sa.national_id_start": "Nasnameya neteweyî ya Siûdî divê bi 1 dest pê bike",
    "validation.nationalId.sa.iqama_start": "Hejmara Îqame / rûniştinê divê bi 2 dest pê bike",
    "validation.nationalId.eg.format": "Nasnameya neteweyî ya Misrê divê bi rastî 14 hejmar be",
    "validation.nationalId.eg.invalid": "Nasnameya neteweyî ya Misrê tarîx an sedsalek nederbasdar e",
    "national_id": "Nasnameya Neteweyî",
    "iqama": "Iqama",
    "passport": "Pasaport",
    "visa": "Vîza",
    "border_number": "Hejmara Sînor",
    "displaced_person": "Kesê Aware",
    "other": "Din",
    "residency": "Iqama",
    "driver_license": "Din",
    "OTHER": "Din",
    male: "Nêr",
    female: "Mê",
    married: "Zewicî",
    single: "Ezeb",
    divorced: "Berdayî",
    separated: "Veqetandî",
    widowed: " بیوەژن/بیوەپیاو",
    msg_quantity_validation_error_title: "Şandina DHS hate girtin",
    msg_quantity_validation_error: "DHS Dental hewce dike ku her operasyona hatî şandin xwedî hejmara 1 be. Divê hejmara operasyonên jêrîn berî şandinê bibe 1:",
    msg_mixed_branch_validation_error_title: "Şandina DHS hate girtin",
    msg_mixed_branch_validation_error: "Divê hemû operasyonên hatî şandin ji heman şaxê bin, ji ber ku daxwaz bi navê şaxê ku xizmet pêşkêş kiriye tê tomarkirin. Operasyonên hilbijartî ji şaxên cuda ne:",
    msg_group_teeth_validation_error_title: "Şandina DHS hate girtin",
    msg_group_teeth_validation_error: "DHS karûbarên ku ji bo gelek diranên hatine destnîşankirin red dike. Divê operasyonên jêrîn berî şandinê li gorî diranê were dabeş kirin:",
    msg_arch_tooth_validation_error_title: "Şandina DHS hate girtin",
    msg_arch_tooth_validation_error: "NPHIES hejmara diranê bi nîşandana FDI dixwaze. Xizmetên ku ji bo hemû kevanê an hemû devî ne, hevwateya FDI nînin û nayên şandin. Divê ev kar berî şandinê ji diranekî diyarkirî re bêne veqetandin:",
    label_tooth_number: "Diran #"    
  },
  nl: {
    btn_get_approval: "Goedkeuring aanvragen",
    msg_select_operations_first: "Selecteer eerst de bewerkingen",
    msg_branch_missing: "Filiaal-ID ontbreekt",
    msg_approval_success: "Goedkeuring succesvol ingediend",
    msg_approval_failed: "Indienen mislukt",
    msg_operations_no_longer_submittable: "Deze behandelingen kunnen niet meer worden verzonden. Sluit dit venster en controleer hun status.",
    modal_title: "DHS-goedkeuring indienen",
    btn_cancel: "Annuleren",
    btn_submit: "Indienen",
    btn_previous: "Vorige",
    btn_next: "Volgende",
    step_general: "Algemeen",
    step_practitioner: "Behandelaar",
    step_diagnosis: "Diagnose",
    step_attachments: "Bijlagen",
    label_visit_reason: "Reden van bezoek",
    label_transaction_type: "Transactietype",
    label_claim_request_type: "Type voorafgaande machtigingsaanvraag",
    label_priority: "Prioriteit",
    label_encounter_status: "Status ontmoeting",
    label_encounter_class: "Klasse ontmoeting",
    label_service_event_type: "Type servicegebeurtenis",
    label_triage_category: "Triagecategorie",
    label_triage_date: "Triagedatum",
    label_intended_length: "Beoogde verblijfsduur",
    label_practitioner_name: "Naam behandelaar",
    label_scfhs: "SCFHS",
    label_speciality_code: "Specialisatiecode",
    label_speciality_name: "Naam specialisatie",
    label_diagnosis_type: "Diagnosetype",
    label_diagnosis_code: "Diagnosecode",
    label_diagnosis_description: "Diagnosebeschrijving",
    label_chief_complaint: "Hoofdklacht",
    label_investigation_result: "Onderzoeksresultaat",
    label_treatment_plan: "Behandelplan",
    label_patient_history: "Patiëntgeschiedenis",
    label_physical_examination: "Lichamelijk onderzoek",
    label_history_present_illness: "Anamnese van huidige ziekte",
    btn_add_diagnosis: "Diagnose toevoegen",
    btn_remove: "Verwijderen",
    msg_unsupported_file: "Niet ondersteund door Nphies",
    msg_file_type_required: "Selectie van bestandstype is vereist",
    placeholder_select_file_type: "Selecteer bestandstype",
    required: "Verplicht",
    step_patient_info: "Patiëntinfo",
    step_request_info: "Aanvraaginfo",
    step_encounter_info: "Ontmoetingsinfo",
    btn_use_code: 'Gebruik deze code',
    msg_no_diagnosis_found: 'Geen diagnose gevonden. Typ een code om handmatig in te voeren.',
    step_services: "Diensten",
    step_review: "Beoordelen",
    title_patient_information: "Patiëntinformatie",
    label_marital_status: "Burgerlijke staat",
    label_date_of_birth: "Geboortedatum",
    label_gender: "Geslacht",
    label_occupation: "Beroep",
    label_identifier_type: "Identificatietype",
    label_identifier_id: "Identificatie-ID",
    label_membership_number: "Lidmaatschapsnummer",
    "auth.nameLength": "ID mag niet langer zijn dan 100 tekens",
    label_policy_number: "Polisnummer",
    label_policy_holder_name: "Naam polishouder",
    label_class_name: "Polisklasse",
    title_claim_preauth_request: "Claim Preautorisatie Aanvraag",
    label_is_transferal: "Is overdracht",
    title_encounter_details: "Details ontmoeting",
    label_admission_date: "Opnamedatum",
    label_discharge_date: "Ontslagdatum",
    msg_discharge_date_error: "Ontslagdatum moet na of gelijk zijn aan opnamedatum",
    msg_admission_date_error: "De opnamedatum kan niet later zijn dan de vroegste servicedatum",
    msg_discharge_date_service_error: "De ontslagdatum kan niet eerder zijn dan de laatste servicedatum",
    placeholder_search_practitioner: "Zoek behandelaar",
    label_scfhs_license: "SCFHS-licentie",
    title_diagnosis_information: "Diagnose-informatie",
    msg_missing_code: "Code ontbreekt",
    msg_missing_type: "Type ontbreekt",
    msg_at_least_one_diagnosis: "Minimaal één diagnose is vereist",
    label_code: "Code",
    label_type: "Type",
    label_description: "Beschrijving",
    title_medical_details: "Medische details",
    title_services_procedures: "Diensten / Procedures",
    label_service_code: "Servicecode",
    label_quantity: "Aantal",
    label_branch: "Vestiging",
    label_unit_price: "Eenheidsprijs",
    label_vat_percentage: "BTW %",
    label_discount_percentage: "Korting %",
    label_discount_amount: "Kortingsbedrag",
    label_vat_amount: "BTW-bedrag (15%)",
    msg_vat_calculated_auto: "Automatisch berekend op 15% na korting",
    label_service_type: "Servicetype",
    title_attachments: "Bijlagen",
    title_supported_file_formats: "Ondersteunde bestandsformaten",
    desc_supported_file_formats: "Let op: alleen PDF, JPEG, JPG en PNG bestanden worden ondersteund voor DHS-goedkeuringen.",
    label_include: "Inclusief",
    label_file_name: "Bestandsnaam",
    label_content_type: "Contenttype",
    label_file_type: "Bestandstype",
    label_unknown: "Onbekend",
    msg_unsupported_file_format: "Niet-ondersteund bestandsformaat",
    label_view: "Bekijken",
    title_review_submit: "Beoordelen & Verzenden",
    title_diagnosis_medical_details: "Diagnose & Medische Details",
    label_name: "Naam",
    label_status: "Status",
    label_qty: "Aant",
    label_yes: "Ja",
    label_no: "Nee",
    relatedApprovalNumber: "Gerelateerd goedkeuringsnummer",
    relatedApprovalRequired: "Gerelateerd goedkeuringsnummer is vereist",
    "validation.nationalId.sa.format": "ID moet exact 10 cijfers lang zijn",
    "validation.nationalId.sa.national_id_start": "Saoedisch nationaal ID moet beginnen met 1",
    "validation.nationalId.sa.iqama_start": "Iqama / verblijfsnummer moet beginnen met 2",
    "validation.nationalId.eg.format": "Egyptisch nationaal ID moet exact 14 cijfers lang zijn",
    "validation.nationalId.eg.invalid": "Egyptisch nationaal ID heeft een ongeldige datum of eeuw",
    "national_id": "Nationaal ID",
    "iqama": "Iqama",
    "passport": "Paspoort",
    "visa": "Visum",
    "border_number": "Grensnummer",
    "displaced_person": "Ontheemde",
    "other": "Anders",
    "residency": "Iqama",
    "driver_license": "Anders",
    "OTHER": "Anders",
    male: "Man",
    female: "Vrouw",
    married: "Getrouwd",
    single: "Ongehuwd",
    divorced: "Gescheiden",
    separated: "Gescheiden van tafel en bed",
    widowed: "Weduwnaar/Weduwe",
    msg_quantity_validation_error_title: "DHS-indiening geblokkeerd",
    msg_quantity_validation_error: "DHS Dental vereist dat elke ingediende handeling een aantal van 1 heeft. De volgende handelingen moeten een aantal van 1 hebben voor verzending:",
    msg_mixed_branch_validation_error_title: "DHS-indiening geblokkeerd",
    msg_mixed_branch_validation_error: "Alle ingediende handelingen moeten tot dezelfde vestiging behoren, omdat de aanvraag wordt ingediend namens de vestiging die de dienst heeft verleend. De geselecteerde handelingen behoren tot verschillende vestigingen:",
    msg_group_teeth_validation_error_title: "DHS-indiening geblokkeerd",
    msg_group_teeth_validation_error: "DHS weigert diensten die aan meerdere tanden zijn toegewezen. De volgende handelingen moeten per tand worden gesplitst voor verzending:",
    msg_arch_tooth_validation_error_title: "DHS-indiening geblokkeerd",
    msg_arch_tooth_validation_error: "NPHIES vereist een tandnummer in FDI-notatie. Behandelingen voor een hele boog of de hele mond hebben geen FDI-equivalent en kunnen niet worden ingediend. De volgende behandelingen moeten vóór indiening aan een specifieke tand worden toegewezen:",
    label_tooth_number: "Tand #"   
  },
  pl: {
    btn_get_approval: "Uzyskaj zgodę",
    msg_select_operations_first: "Proszę najpierw wybrać operacje",
    msg_branch_missing: "Brak identyfikatora oddziału",
    msg_approval_success: "Wniosek o zatwierdzenie przesłany pomyślnie",
    msg_approval_failed: "Przesyłanie nie powiodło się",
    msg_operations_no_longer_submittable: "Tych zabiegów nie można już wysłać. Zamknij to okno i sprawdź ich status.",
    modal_title: "Przesyłanie zatwierdzenia DHS",
    btn_cancel: "Anuluj",
    btn_submit: "Wyślij",
    btn_previous: "Poprzedni",
    btn_next: "Dalej",
    step_general: "Ogólne",
    step_practitioner: "Lekarz prowadzący",
    step_diagnosis: "Diagnoza",
    step_attachments: "Załączniki",
    label_visit_reason: "Powód wizyty",
    label_transaction_type: "Typ transakcji",
    label_claim_request_type: "Typ wniosku o wstępną autoryzację",
    label_priority: "Priorytet",
    label_encounter_status: "Status wizyty",
    label_encounter_class: "Klasa wizyty",
    label_service_event_type: "Typ zdarzenia medycznego",
    label_triage_category: "Kategoria triage",
    label_triage_date: "Data triage",
    label_intended_length: "Planowany czas pobytu",
    label_practitioner_name: "Imię i nazwisko lekarza",
    label_scfhs: "SCFHS",
    label_speciality_code: "Kod specjalizacji",
    label_speciality_name: "Nazwa specjalizacji",
    label_diagnosis_type: "Typ diagnozy",
    label_diagnosis_code: "Kod diagnozy",
    label_diagnosis_description: "Opis diagnozy",
    label_chief_complaint: "Główna dolegliwość",
    label_investigation_result: "Wynik badania",
    label_treatment_plan: "Plan leczenia",
    label_patient_history: "Historia choroby pacjenta",
    label_physical_examination: "Badanie fizykalne",
    label_history_present_illness: "Historia obecnej choroby",
    btn_add_diagnosis: "Dodaj diagnozę",
    btn_remove: "Usuń",
    msg_unsupported_file: "Nieobsługiwane przez Nphies",
    msg_file_type_required: "Wybór typu pliku jest wymagany",
    placeholder_select_file_type: "Wybierz typ pliku",
    required: "Wymagane",
    step_patient_info: "Dane pacjenta",
    step_request_info: "Dane wniosku",
    step_encounter_info: "Dane wizyty",
    btn_use_code: 'Użyj tego kodu',
    msg_no_diagnosis_found: 'Nie znaleziono diagnozy. Wpisz kod, aby wprowadzić ręcznie.',
    step_services: "Usługi",
    step_review: "Podsumowanie",
    title_patient_information: "Informacje o pacjencie",
    label_marital_status: "Stan cywilny",
    label_date_of_birth: "Data urodzenia",
    label_gender: "Płeć",
    label_occupation: "Zawód",
    label_identifier_type: "Typ identyfikatora",
    label_identifier_id: "ID identyfikatora",
    label_membership_number: "Numer członkowski",
    "auth.nameLength": "Numer identyfikacyjny nie może przekraczać 100 znaków",
    label_policy_number: "Numer polisy",
    label_policy_holder_name: "Nazwisko posiadacza polisy",
    label_class_name: "Klasa polisy",
    title_claim_preauth_request: "Wniosek o wstępną autoryzację roszczenia",
    label_is_transferal: "Czy jest to przeniesienie",
    title_encounter_details: "Szczegóły wizyty",
    label_admission_date: "Data przyjęcia",
    label_discharge_date: "Data wypisu",
    msg_discharge_date_error: "Data wypisu musi być późniejsza lub równa dacie przyjęcia",
    msg_admission_date_error: "Data przyjęcia nie może być późniejsza niż najwcześniejsza data usługi",
    msg_discharge_date_service_error: "Data wypisu nie może być wcześniejsza niż najpóźniejsza data usługi",
    placeholder_search_practitioner: "Szukaj lekarza",
    label_scfhs_license: "Licencja SCFHS",
    title_diagnosis_information: "Informacje o diagnozie",
    msg_missing_code: "Brak kodu",
    msg_missing_type: "Brak typu",
    msg_at_least_one_diagnosis: "Wymagana jest co najmniej jedna diagnoza",
    label_code: "Kod",
    label_type: "Typ",
    label_description: "Opis",
    title_medical_details: "Szczegóły medyczne",
    title_services_procedures: "Usługi / Procedury",
    label_service_code: "Kod usługi",
    label_quantity: "Ilość",
    label_branch: "Oddział",
    label_unit_price: "Cena jednostkowa",
    label_vat_percentage: "VAT %",
    label_discount_percentage: "Rabat %",
    label_discount_amount: "Kwota rabatu",
    label_vat_amount: "Kwota VAT (15%)",
    msg_vat_calculated_auto: "Obliczane automatycznie jako 15% po rabacie",
    label_service_type: "Typ usługi",
    title_attachments: "Załączniki",
    title_supported_file_formats: "Obsługiwane formaty plików",
    desc_supported_file_formats: "Pamiętaj, że dla zatwierdzeń DHS obsługiwane są wyłącznie pliki PDF, JPEG, JPG i PNG.",
    label_include: "Dołącz",
    label_file_name: "Nazwa pliku",
    label_content_type: "Typ zawartości",
    label_file_type: "Typ pliku",
    label_unknown: "Nieznany",
    msg_unsupported_file_format: "Nieobsługiwany format pliku",
    label_view: "Widok",
    title_review_submit: "Sprawdź i wyślij",
    title_diagnosis_medical_details: "Diagnoza i szczegóły medyczne",
    label_name: "Nazwa",
    label_status: "Status",
    label_qty: "Ilość",
    label_yes: "Tak",
    label_no: "Nie",
    relatedApprovalNumber: "Powiązany numer zatwierdzenia",
    relatedApprovalRequired: "Powiązany numer zatwierdzenia jest wymagany",
    "validation.nationalId.sa.format": "Identyfikator musi składać się z dokładnie 10 cyfr",
    "validation.nationalId.sa.national_id_start": "Saudyjski identyfikator narodowy musi zaczynać się od 1",
    "validation.nationalId.sa.iqama_start": "Numer Iqama / rezydencji musi zaczynać się od 2",
    "validation.nationalId.eg.format": "Egipski identyfikator narodowy musi składać się z dokładnie 14 cyfr",
    "validation.nationalId.eg.invalid": "Egipski identyfikator narodowy ma nieprawidłową datę lub wiek",
    "national_id": "Dowód osobisty",
    "iqama": "Iqama",
    "passport": "Paszport",
    "visa": "Wiza",
    "border_number": "Numer graniczny",
    "displaced_person": "Osoba przesiedlona",
    "other": "Inne",
    "residency": "Iqama",
    "driver_license": "Inne",
    "OTHER": "Inne",
    male: "Mężczyzna",
    female: "Kobieta",
    married: "Żonaty/Mężatka",
    single: "Kawaler/Panna",
    divorced: "Rozwiedziony/a",
    separated: "W separacji",
    widowed: "Wdowiec/Wdowa",
    msg_quantity_validation_error_title: "Przesyłanie DHS zablokowane",
    msg_quantity_validation_error: "DHS Dental wymaga, aby każda przesłana operacja miała ilość 1. Poniższe operacje muszą mieć ilość 1 przed przesłaniem:",
    msg_mixed_branch_validation_error_title: "Przesyłanie DHS zablokowane",
    msg_mixed_branch_validation_error: "Wszystkie przesyłane operacje muszą należeć do tego samego oddziału, ponieważ wniosek jest składany w imieniu oddziału, który wykonał usługę. Wybrane operacje należą do różnych oddziałów:",
    msg_group_teeth_validation_error_title: "Przesyłanie DHS zablokowane",
    msg_group_teeth_validation_error: "DHS odrzuca usługi przypisane do wielu zębów. Poniższe operacje należy podzielić według zęba przed przesłaniem:",
    msg_arch_tooth_validation_error_title: "Przesyłanie DHS zablokowane",
    msg_arch_tooth_validation_error: "Ten NPHIES wymaga numeru zęba w notacji FDI. Usługi obejmujące cały łuk lub całą jamę ustną nie mają odpowiednika FDI i nie mogą zostać przesłane. Poniższe zabiegi muszą zostać przypisane do konkretnego zęba przed przesłaniem:",
    label_tooth_number: "Ząb #"    
  }
};

export const addTranslationResources = (i18next: typeof i18n) => {
  i18next.addResourceBundle("ar", "dhsApprovalSubmission", resources.ar);
  i18next.addResourceBundle("en", "dhsApprovalSubmission", resources.en);
  i18next.addResourceBundle("ckb", "dhsApprovalSubmission", resources.ckb);
  i18next.addResourceBundle("el", "dhsApprovalSubmission", resources.el);
  i18next.addResourceBundle("fr", "dhsApprovalSubmission", resources.fr);
  i18next.addResourceBundle("it", "dhsApprovalSubmission", resources.it);
  i18next.addResourceBundle("ku", "dhsApprovalSubmission", resources.ku);
  i18next.addResourceBundle("nl", "dhsApprovalSubmission", resources.nl);
  i18next.addResourceBundle("pl", "dhsApprovalSubmission", resources.pl);
};
